import { Button, CloudUploadIcon, Grid } from '@freighthub/silhouette-core'
import {
  DocumentInterface,
  DocumentsUploadDialog,
  DocumentUploadButton,
  ProgressEventHandler,
} from 'features/Documents'
import { FC } from 'react'
import { useUIStore } from 'service/useUIStore'
import { useI18n } from 'utils/localisation'

type BookingDocumentUploadHeaderProps = {
  onUpload: (file: File, onProgress: ProgressEventHandler, documentType: string) => Promise<DocumentInterface>
}

export const ManualQuoteDocumentUploadButton: FC<BookingDocumentUploadHeaderProps> = ({ onUpload }) => {
  const { translate } = useI18n()
  const { snack } = useUIStore()

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid>
        <DocumentUploadButton
          upload={onUpload}
          handleError={(e) => snack.notifyError(e)}
          renderUploadButton={({ onClickHandler }) => (
            <Button variant="contained" startIcon={<CloudUploadIcon />} onClick={onClickHandler}>
              {translate('booking_documents-button_label')}
            </Button>
          )}
          renderUploadDialog={(props) => <DocumentsUploadDialog {...props} />}
        />
      </Grid>
    </Grid>
  )
}
